<ng-container *ngIf="equipments$ | async as equipments">
  <form *ngIf="equipments" nz-form class="display-inline">
    <nz-form-item nz-row nzAlign="middle">
      <nz-form-control class="display-inline">
        <nz-select
          nzShowSearch
          class="selector"
          [formControl]="control"
          nzSize="large"
          [nzLoading]="(this.loading$ | async) ?? false"
          nzPlaceHolder="No equipment"
        >
          <nz-option
            *ngFor="let equipment of equipments; trackBy: trackByRef"
            [nzValue]="equipment"
            [nzLabel]="equipment"
          ></nz-option>
        </nz-select>
      </nz-form-control>
    </nz-form-item>
  </form>
</ng-container>
